export const COLOR_CHECKBOX_CUSTOM = '#FEA628';
export const COLOR_CHECKBOX_NOT_ACTIVE = '#979797';
export const COLOR_MENU_SELECTED = '#f9c883';
